<script lang="ts">

    import {i18N} from "../../helper";

    export let value: NoteEditableValueType;
    export let canEdit: boolean = true;
    export let canAdd: boolean = true;
    export let mode: string;

    let created = -1;

    const removeCommentById = (id: number) => {
        for (var i = 0; i < value.length; i++) {
            if (value[i].id === id) {
                value.splice(i, 1);
            }
        }
        value = value;
    }

    const confirmRemoval = (id: number) => {
        if (window.confirm(i18N().delete_note_confirm)) {
            removeCommentById(id);
        }
    }

    const addNew = () => {
        let newValue: SingleNoteValueType = {content: "", id: created, date: "", added_by: "", edit: true}
        let computedId = -1*created;
        value = [newValue, ...value];

        setTimeout(() => document.querySelector<HTMLTextAreaElement>('#acpnote_' + computedId +' textarea').focus(), 100)
        created--;
    }

    export const getValue = () => {
        return value;
    }

</script>

<div class="acpne">
	{#if canAdd }
		<div class="acpne__new">
			<a href={"#"} on:click|preventDefault={addNew}>+ {i18N().add_note}</a>
		</div>
	{/if}
	<div class="acpne__notes">
		{#if value.length === 0 & mode === 'system' }
			<div class="acpne__no-notes">
				{i18N().no_notes}
			</div>
		{/if}
		{#each value as note (note.id)}
			<div class="acpne-note -{mode}" id="acpnote_{note.id*-1}">
				{#if canEdit || note.edit }
					{#if note.id < 0 & mode === 'customer' }
						<div class="acpne-customer-warning">
							<span class="dashicons dashicons-email-alt"></span>
							{i18N().custom_note_alert}
						</div>
					{/if}
					<textarea style="font-size:13px;" name="{note.id}" cols="60" rows="2" bind:value={note.content} required></textarea>
				{:else }
					<div class="acpne-note__read">{@html note.content}</div>
				{/if}
				<div class="acpne-note__meta">
					<span class="acpne-note__meta__item -date">
						<time>{note.date}</time>
						{#if note.added_by}{i18N().added_by} {note.added_by}{/if}
					</span>
					<a href={"#"} class="acpne-note__meta__item -delete" on:click|preventDefault={ () => confirmRemoval( note.id ) }>{i18N().delete_note}</a>
				</div>
			</div>

		{/each}
	</div>
</div>